'use strict';

import 'lib/jquery.stickem';
import 'lib/imagesloaded.pkgd';

$('.fb-nav ul li a').on('click', function (click) {
  $('.fb-nav').toggleClass('visible');
  $('body').toggleClass('nav-open');
  $('#menuToggle').toggleClass('active');
});

$('body').imagesLoaded(function () {
  // make ambassadors in sidebar stick
  $('.content').stickem({
    container: '.sidebar',
    item: '.stick',
    offset: 60
  });
});

const LOG_TO_CONSOLE = false;

function log () {
  if (LOG_TO_CONSOLE && !!window.console) {
    console.log.apply(console, [].slice.call(arguments));
  }
}

// Sticky Navigation
const RENDER_INTERVAL = 200;
let fixedNavScrollOffset;
const $interiorNav = $('.momentum__interior-nav-container');
let lastRenderTime = 0;
let isPinned = false;
const $parallax = $('#parallax');
const $parallax2 = $('#parallax2');

const windowHeight = $(window).height();
const docHeight = $(document).height();

function initInteriorNav () {
  log('initInteriorNav');
  const wasPinned = isPinned;
  if (wasPinned) {
    // unpin temporarily for calculations
    $interiorNav.removeClass('is-pinned');
  }

  // store the offset for now
  fixedNavScrollOffset = $interiorNav.offset().top;
  log(`fixedNavScrollOffset set to ${fixedNavScrollOffset}`);

  // return to previous state
  if (wasPinned) {
    $interiorNav.addClass('is-pinned');
  }
}

function runAnimations () {
  // make sure we're not rendering more often than needed
  const now = (new Date()).getTime();
  if (now - lastRenderTime > RENDER_INTERVAL) {
    // continue rendering...
    lastRenderTime = now;

    if (!fixedNavScrollOffset) {
      initInteriorNav();
    }

    const scrollY = window.scrollY || window.pageYOffset || 0;

    if (scrollY > fixedNavScrollOffset) {
      if (!isPinned) {
        log('pinning now');
        $interiorNav.addClass('is-pinned');
        isPinned = true;
      }
    } else {
      if (isPinned) {
        log('unpinning');
        $interiorNav.removeClass('is-pinned');
        isPinned = false;
      }
    }
  }

  // the top section parallax
  if (scrollY < 700) {
    if ($parallax.length > 0) {
      $parallax.css('top', `${scrollY / 2}px`);
      $parallax2.css('top', `${scrollY / 2.75}px`);
    }
  } else {
    scrollingNavigation();
  }

  window.requestAnimationFrame(runAnimations);
}

function debounce (func, wait, immediate) {
  let timeout;
  return function () {
    const context = this; const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) { func.apply(context, args); }
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) { func.apply(context, args); }
  };
}

$(window).resize(debounce(initInteriorNav, 300));

// fancy pants anchor links
$interiorNav.find('a').on('click', function (click) {
  if (window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
    let target = $(this.hash);
    target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
    if (target.length) {
      $('html,body').animate({
        scrollTop: target.offset().top,
        easing: 'swing'
      }, 600);
      return false;
    }
  }
});

if ('requestAnimationFrame' in window) {
  window.requestAnimationFrame(runAnimations);
}

// Fancy Nav Scroll with Section
const aChildren = $('.momentum__interior-nav li').children();
const aArray = [];
for (let i = 0; i < aChildren.length; i++) {
  const aChild = aChildren[i];
  const $child = $(aChild);
  aArray.push($child);
}

let revealedByScroll = false;

function scrollingNavigation () {
  const windowPos = $(window).scrollTop();
  const modifiedPos = windowPos + 60;

  for (let i = 0; i < aArray.length; i++) {
    const $child = aArray[i];
    const theID = $child.attr('href');
    const divPos = $(theID).offset().top;
    const divHeight = $(theID).height();
    if (modifiedPos >= divPos && modifiedPos < (divPos + divHeight)) {
      const $parent = $(`a[href="${theID}"]`).parent();

      if (!$parent.hasClass('reveal')) {
        $parent.addClass('reveal');
        revealedByScroll = true;
      }
    } else {
      if (revealedByScroll) {
        $(`a[href="${theID}"]`).parent().removeClass('reveal');
      }
    }
  }

  if (modifiedPos + windowHeight === docHeight) {
    if (!$('.momentum__interior-nav li:last-child a').parent().hasClass('reveal')) {
      const navActiveCurrent = $('.reveal').attr('href');
      $(`a[href="${navActiveCurrent}"]`).parent().removeClass('reveal');
      $('.momentum__interior-nav li:last-child a').parent().addClass('reveal');
    }
  }
}

// Hide each section until click on mobile
$('footer').addClass('toggle-hide');

$('#introduction .continue, .fb-nav .financials').click(function () {
  $('#financials').removeClass('toggle-hide');
  $('#introduction .continue').addClass('toggle-hide');
});
$('#financials .continue, .fb-nav .childhood').click(function () {
  $('#childhoodcancer').removeClass('toggle-hide');
  $('#financials .continue').addClass('toggle-hide');
});
$('#childhoodcancer .continue, .fb-nav .impact').click(function () {
  $('#ourimpact').removeClass('toggle-hide');
  $('#childhoodcancer .continue').addClass('toggle-hide');
});
$('#ourimpact .continue, .fb-nav .events').click(function () {
  $('#community').removeClass('toggle-hide');
  $('#ourimpact .continue').addClass('toggle-hide');
});
$('#community .continue, .fb-nav .advocacy').click(function () {
  $('#advocacy').removeClass('toggle-hide');
  $('footer').removeClass('toggle-hide');
  $('.hero--end').removeClass('toggle-hide');
  $('#community .continue').addClass('toggle-hide');
});
